import type { LocationDetail } from '@/definitions/location'

export interface LocationRow {
  location: LocationDetail
  isPrimary: boolean
}

/**
 * Pairs each of an organization's locations with its primary standing, primary first.
 *
 * `primaryLocationId` is the organization's, so a location matches it or does not;
 * an organization with none simply has no primary row. The primary location leads
 * the list because it is the one that stands for the organization; every other row
 * keeps the response's oldest-first order.
 */
export const buildLocationRows = (
  locations: LocationDetail[],
  primaryLocationId: string | null
): LocationRow[] => {
  const rows = locations.map((location) => ({
    location,
    isPrimary: primaryLocationId !== null && primaryLocationId === location.id,
  }))

  // Array.prototype.sort is stable, so the non-primary rows hold their order.
  return rows.sort((first, second) => Number(second.isPrimary) - Number(first.isPrimary))
}
